import FinalProjectImage from "../../../assets/images/projects/final-project/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Uni-Final Project: DISC video",
  description: "An educational animated Indonesia video that introduces DISC Personality",
  image: FinalProjectImage,
  path: "final-project",
} as ProjectDataProps;
